export default class UnauthenticatedException extends Error {
  constructor(...args) {
    super(...args);
    this.message = 'user is not authenticated.';
  }
}
